import Assistant from '../pages/Assistant';
import Account from '../pages/Account';
import Plan from '../pages/Plan';
import { chatbubbleEllipses, cube, fileTrayFull, layers } from 'ionicons/icons';
import { Initiative, NestedRoute } from './Types';

import Home from '../Home';
import Prompts from '../pages/Prompts';
import Templates from '../pages/Templates';
import InitiativePage from '../pages/Initiative';
import Artifacts from '../pages/Artifacts';
import AssistantSettings from '../pages/AssistantSettings';
import InitiativeSettings from '../pages/InitiativeSettings';

const coreRoutes: NestedRoute[] = [
  { path: '/', component: Home, exact: true, label: "home" },
  { path: '/templates', component: Templates, exact: true, label: "templates" },
  { path: '/prompts', component: Prompts, exact: true, label: "prompts" },
  { path: '/plan', component: Plan, exact: true, label: "plan" },
  { path: '/account', component: Account, exact: true, label: "account" }
];

const generateAssistantRoutes = (data : any) => {

  if (data != null) {

    return data.flatMap((assistant: { slug: string; name: string }) => ([
      {
        path: `/${assistant.slug}`,
        component: Assistant,
        exact: true,
        label: assistant.name,
        icon: chatbubbleEllipses, 
        menu: true
      },
      {
        path: `/${assistant.slug}/settings`,
        component: AssistantSettings,
        exact: true,
        label: `${assistant.name} Settings`,
        icon: chatbubbleEllipses,
        menu: false
      }
    ]));      
  }
  else {

    return [];
  }
};

const initiativeRoutes: NestedRoute[] = [
  { 
    path: '',
    component: InitiativePage, 
    exact: true, 
    menu: true,
    icon: layers, 
    label: 'Overview'
  },
  {
    path: `/settings`,
    component: InitiativeSettings,
    exact: true,
    label: `Settings`,
    icon: layers,
    menu: false
  }

]  

const artifactRoutes: NestedRoute[] = [
  { 
    path: '/share',
    component: Artifacts, 
    exact: true, 
    menu: true,
    icon: fileTrayFull, 
    label: 'Deliverable'
  }
]  

const generateRoutes = (initiative : Initiative | undefined): NestedRoute[] => {
 
  if (!initiative || initiative == null)
    return [];

  if (initiative.initiative_type === "launchpad") {
  
    return [...coreRoutes, ...initiativeRoutes, ...generateAssistantRoutes(initiative.assistants), ...artifactRoutes];
  }  
  else {
    
    return [...coreRoutes];
  }  
}

export default generateRoutes;

